import { endImpersonation } from '../../lib/api/impersonation';
import { useImpersonation } from './useImpersonation';

// ─────────────────────────────────────────────────────────────────────
// «DU ARBEIDER NÅ SOM …» (RBAC-3).
//
// LOUD ON PURPOSE. A context grants StarPoint administrative authority inside
// a customer's organization, and the expensive mistake is not starting one —
// it is forgetting you are in one and acting on the wrong club's data. So this
// is a persistent bar across the top with the organization named and one
// obvious way out, not a subtle dropdown state.
// ─────────────────────────────────────────────────────────────────────
export function ImpersonationBanner() {
  const state = useImpersonation();
  if (!state) return null;

  return (
    <div
      data-testid="sa-impersonation-banner"
      role="status"
      className="sticky top-0 z-50 flex items-center gap-3 px-4 py-2 text-sm font-semibold"
      style={{ background: '#b45309', color: '#fff' }}
    >
      <span className="font-mono text-[11px] uppercase tracking-wider opacity-90">
        Du arbeider nå som
      </span>
      <span data-testid="sa-impersonation-org">{state.organization.name}</span>
      <span className="font-mono text-[11px] opacity-80">
        til {new Date(state.expiresAt).toLocaleTimeString('nb-NO', { timeStyle: 'short' })}
      </span>
      <button
        type="button"
        data-testid="sa-impersonation-end"
        onClick={() => void endImpersonation()}
        className="ml-auto rounded px-3 py-1 text-xs font-bold"
        style={{ background: '#fff', color: '#b45309' }}
      >
        Avslutt
      </button>
    </div>
  );
}
